import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a3be216"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2a3be216&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3be216')) {
      api.createRecord('2a3be216', component.options)
    } else {
      api.reload('2a3be216', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a3be216", function () {
      api.rerender('2a3be216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/permissions/index.vue"
export default component.exports